// The meter detail view is the list of its tariff contracts.
import ContractsList from "pages/ManageContracts/List";

function SingleMeter() {
  return <ContractsList />;
}

export default SingleMeter;
